import { defineStore } from 'pinia';
import ServiceExec, { customToast } from '@/common/utils/ServiceExec';
import { inquiry } from '@/common/service/api/apiList';
import router from '@/router';
import { downloadXl } from '@/common/utils/Util';

const { getAllInquiry, getInquiry, answerPath, xl, adminRead } = inquiry;

export const useInquiryStore = defineStore('inquiry', {
  state: () => ({
    condition: {
      page: 1,
      limit: 10,
      startDate: null,
      endDate: null,
      searchText: null,
      isAnswered: null
    },
    inquiryList: [],
    inquiry: {},
    adminReadStatus: false
  }),
  getters: {},
  actions: {
    async getAllInquiry(params) {
      this.condition = {
        ...this.condition,
        ...params
      };
      const { status, data } = await ServiceExec.get(getAllInquiry, this.condition);
      if (status !== ServiceExec.status.OK) {
        return false;
      }
      const { pageInfo, list } = data;
      this.condition = { ...this.condition, ...pageInfo };
      this.inquiryList = list;
    },
    async getInquiry(inquiryNo) {
      const { status, data } = await ServiceExec.get(getInquiry + inquiryNo);
      if (status !== ServiceExec.status.OK) {
        return false;
      }
      this.inquiry = data;
    },
    async answer(inquiryNo, answer) {
      const { status, data } = await ServiceExec.patch(answerPath(inquiryNo), {answer});
      if (status === ServiceExec.status.OK) {
        await router.push('/inquiry');
        await customToast(status, data, '등록이 완료되었습니다.');
      }
    },
    async setInquiry() {
      this.inquiry = {};
    },
    async xlDownload() {
      const { status, data } = await ServiceExec.xl(xl, this.condition);
      if (status !== ServiceExec.status.OK) {
        await customToast(status, '다운로드할 내역이 없습니다.');
        return;
      }
      downloadXl(data, '일대일 문의 관리');
      return true;
    },
    async adminRead() {
      const { status, data } = await ServiceExec.get(adminRead);
      if (status === ServiceExec.status.OK) {
        this.adminReadStatus = data;
        return data;
      }
      return false;
    }
  },
  persist: true
});